import React from 'react';
import { arrayforMulti } from './utils';
import MultiSelect from './MultiSelect';

const SelectCustomer = ({ customers, onChange, selectedItems }) => {
    const allItems = arrayforMulti(customers);

    return (
        <MultiSelect
            allItems={allItems}
            onChange={onChange}
            selectedItems={selectedItems}
            title="Customers"
            placeholder="Search Customers"
        />
    );
};

export default SelectCustomer;
